import { render, staticRenderFns } from "./AddLegacyData.vue?vue&type=template&id=39d3623a&scoped=true"
import script from "./AddLegacyData.vue?vue&type=script&lang=js"
export * from "./AddLegacyData.vue?vue&type=script&lang=js"
import style0 from "./AddLegacyData.vue?vue&type=style&index=0&id=39d3623a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d3623a",
  null
  
)

export default component.exports